export const TEAM_TEMPLATE = `
    <ul>
    <li>Print/Online Promotion</li>
    <li>TV Promotion</li>
    <li>Radio Promotion</li>
    <li>Legal Contact</li>
  </ul>
`

export const CAMPAIGN_INFO_TEMPLATE = `
  <h1>PROJECT INFO</h1>
  <ul>
    <li>Release Dates</li>
    <li>Live Dates</li>
    <li>Artist Availability</li>
    <li>Tool Availability</li>
  </ul>
  <p><br></p>
  <h1>TOOLS</h1>
  <ul>
    <li>Folders with available assets</li>
    <li>Music</li>
  </ul>
  <p><br></p>
  <h1>WIKIPEDIA</h1>
  <ul>
    <li>Link to Wikipedia</li>
  </ul>
  <p><br></p>
  <h1>LINKS</h1>
  <ul>
    <li>Spotify</li>
    <li>Website</li>
    <li>Facebook</li>
    <li>Instagram</li>
    <li>Youtube</li>
    <li>Etc.</li>
  </ul>
`

export const toolbarModules = {
  minimal: {
    toolbar: {
      container: [
        [{ header: [1, false] }, { font: [false, 'monospace'] }],
        ['bold', 'italic', 'underline', 'strike'],
        ['link', { list: 'bullet' }, { list: 'ordered' }],
        ['clean']
      ]
    },
    magicUrl: true,
    pasteInterceptor: {
      minimal: true
    }
  },
  extended: {
    toolbar: {
      container: [
        [{ header: [1, 2, 3, false] }, { font: [false, 'monospace'] }],
        ['bold', 'italic', 'underline', 'strike', { color: [] }, { background: [] }],
        ['link', { list: 'bullet' }, { list: 'ordered' }],
        ['image', 'embed'],
        ['clean']
      ],
      handlers: {
        embed: () => {}
      }
    },
    pasteInterceptor: true,
    socialEmbedder: true,
    magicUrl: true,
    clearImageResize: true,
    blotFormatter: {}
  }
}
